<template>
  <component :is="currentComponent"></component>
</template>

<script>
import MobileComponent from './components/MobileComponent.vue'
import TabletComponent from './components/TabletComponent.vue'
export default {
  name: 'App',
  components: {
    MobileComponent,
    TabletComponent
  },
  data() {
    return {
      isMobile: false,
      currentComponent: 'MobileComponent' // 默认组件
    };
  },
  mounted() {
    this.updateComponent();
    window.addEventListener('resize', this.updateComponent);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateComponent);
  },
  methods: {
    updateComponent() {
      this.currentComponent = window.innerWidth > 1000 ? 'TabletComponent' : 'MobileComponent';
    }
  }

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  box-sizing: border-box;
}
</style>
